import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "mb-l pb-xs border-gray-200 border-b-2 flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center justify-between" }

import { computed, ref } from "vue";

import { ManagedPatient } from "@/interfaces/managedPatient";
import { supabase } from "@/helpers/supabase";
import { useSessionStore } from "@/store/sessionStore";
import { ManagedPatientKey } from "@/interfaces/managedPatient";
import { encryptSymmetric } from "@/helpers/encryption";
import DialogCard from "@/components/DialogCard.vue";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import IconButton from "@/components/IconButton.vue";
import { localeDateString } from "@/helpers/datehelper";
import ProfileForm from "./ProfileForm.vue";
import ProfileHistory from "./ProfileHistory.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileData',
  props: {
    managedPatient: {},
    managedPatientKey: {}
  },
  setup(__props: any) {

const sessionStore = useSessionStore();
const isEditingProfile = ref<boolean>(false);
const isShowingHistoryOf = ref<number | null>(null);
const props = __props;
const managedPatient = computed(() => props.managedPatient);

// Profile
const profileModel = ref<any>({});

function edit() {
  isEditingProfile.value = true;
  profileModel.value = JSON.parse(
    JSON.stringify(managedPatient.value?.currentProfile)
  );
}
async function saveProfile(profileModel: any) {
  if (
    !props.managedPatientKey.decrypted_symmetric_key ||
    !managedPatient.value.id ||
    !sessionStore.selectedCareProviderGroup?.id
  )
    return;

  const encryptedProfile = await encryptSymmetric(
    JSON.stringify(profileModel),
    props.managedPatientKey.decrypted_symmetric_key
  );

  await supabase
    .from("managedPatient_data")
    .insert({
      managed_patient_id: managedPatient.value.id,
      used_key_id: props.managedPatientKey.key_id,
      nonce: encryptedProfile.nonce,
      encrypted_data: encryptedProfile.encryptedMessage,
      owner_care_provider_group_id: sessionStore.selectedCareProviderGroup.id,
      type: 1,
    })
    .returns<ManagedPatient[]>();

  window._paq.push(["trackEvent", "PatientProfile", "update", undefined]);
  isEditingProfile.value = false;
}

async function changelog() {
  window._paq.push([
    "trackEvent",
    "PatientProfileHistory",
    "show",
    props.managedPatient.id,
  ]);

  isShowingHistoryOf.value = props.managedPatient.id;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(UmanaHeadline, { h: "h2" }, {
        default: _withCtx(() => [
          _createTextVNode(" Profil ")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(IconButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changelog())),
          icon: "changeLog"
        }),
        _createVNode(IconButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (edit())),
          class: "ml-xs",
          icon: "pen"
        })
      ])
    ]),
    _createVNode(UmanaHeadline, {
      h: "h3",
      class: "mb-xs"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Name ")
      ]),
      _: 1
    }),
    _createTextVNode(" " + _toDisplayString(managedPatient.value.currentProfile?.firstName) + " " + _toDisplayString(managedPatient.value.currentProfile?.lastName) + " ", 1),
    (managedPatient.value.currentProfile?.sex)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(["♂", "♀"][managedPatient.value.currentProfile?.sex]), 1)
        ], 64))
      : _createCommentVNode("", true),
    (managedPatient.value.currentProfile?.birthday)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(UmanaHeadline, {
            h: "h3",
            class: "mb-xs mt-l"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Geburtstag ")
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_unref(localeDateString)(managedPatient.value.currentProfile?.birthday)), 1)
        ], 64))
      : _createCommentVNode("", true),
    (managedPatient.value.currentProfile?.veka)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(UmanaHeadline, {
            h: "h3",
            class: "mb-xs mt-l"
          }, {
            default: _withCtx(() => [
              _createTextVNode("VeKa:")
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(managedPatient.value.currentProfile.veka), 1)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(DialogCard, {
      "is-visible": isEditingProfile.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (isEditingProfile.value = false)),
      title: "Profil bearbeiten",
      "show-footer": false
    }, {
      default: _withCtx(() => [
        _createVNode(ProfileForm, {
          onSaveProfile: saveProfile,
          "is-editing": true,
          "profile-model": profileModel.value
        }, null, 8, ["profile-model"])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createVNode(ProfileHistory, {
      "of-user": isShowingHistoryOf.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (isShowingHistoryOf.value = null))
    }, null, 8, ["of-user"])
  ]))
}
}

})